import { render, staticRenderFns } from "./studentImport.vue?vue&type=template&id=f6558704&scoped=true&"
import script from "./studentImport.vue?vue&type=script&lang=js&"
export * from "./studentImport.vue?vue&type=script&lang=js&"
import style0 from "./studentImport.vue?vue&type=style&index=0&id=f6558704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6558704",
  null
  
)

export default component.exports